import Phaser from 'phaser';
import { ModalSheet } from './modal-sheet';
import { ModalSheetConfig } from './modal-sheet/modal-sheet.types';

export class HistorySheet<TemplateData> extends ModalSheet<TemplateData> {
  constructor(
    scene: Phaser.Scene,
    config: ModalSheetConfig<TemplateData> = {},
  ) {
    super(scene, { ...config, iconKey: 'book' });
  }
  protected createContent(content: Phaser.GameObjects.Container): void {
    const element = this.createDomContent('history', this.cfg.templateData);

    content.add([element]);
  }
}
